import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Error from './pages/Auth/SignIn/Error';
import Loader from './features/Loader';
import { loadAppData } from './redux/appActions';
import { useAuth } from './features/Auth/index';

export default function DataProvider(props) {
  const { currentSession } = useAuth();
  const dispatch = useDispatch();

  const load = useCallback(
    async () => await dispatch(loadAppData()).unwrap(),
    []
  );

  return (
    <Loader
      promiseFn={load}
      watch={currentSession?.uid}
      errorComponent={error => <Error values={{ error }} />}
    >
      {props.children}
    </Loader>
  );
}

DataProvider.propTypes = {
  children: PropTypes.node,
};
